// A service's title links to the contact form and fills in its subject.
// Without this script the link still works: it reloads the page with the
// subject in the URL, and the form picks it up from there.
const subjectLinksInit = function() {
	const form = document.getElementById('services-form');
	const section = document.getElementById('contact');
	if (!form || !section) {
		return;
	}
	document.querySelectorAll('a[data-subject]').forEach((link) => {
		link.addEventListener('click', (event) => {
			event.preventDefault();
			form.elements.subject.value = link.dataset.subject;
			section.scrollIntoView({ behavior: document.documentElement.dataset.motion === 'reduce' ? 'auto' : 'smooth' });
			// Keyboard and screen reader users land in the form, not back at the card.
			form.elements.email.focus({ preventScroll: true });
		});
	});
}

subjectLinksInit();
